import React, { useState } from 'react';
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import Button from 'src/common/components/button/Button';
import { makeStyles } from '@material-ui/core/styles';
import {
    checkImpersonationActive,
    checkProxyActive,
    convertDateToISOString,
    displayDeniedOverride,
} from 'src/utils/util';
import {
    setFilters,
    getListData,
    setActionItemsOnly,
    setListViewStartDate,
    setListViewEndDate,
    putFilterOptions,
    setSelectedCalendarView,
    setOrderCondition,
} from 'src/pages/home/redux/actions';
import DatePickerTo from 'src/assets/images/DatePickerTo.svg';
import DatePickerFrom from 'src/assets/images/DatePickerFrom.svg';

// component imports
import FilterResultsPanel from 'src/common/organisms/filterResultsPanel/components/FilterResultsPanelCalender';
import Datepicker from 'src/common/components/datePicker/DatePicker';
import ToggleButton from 'src/common/components/toggleButton/ToggleButton';

// Library imports
import { useSelector, useDispatch } from 'react-redux';
import { setOrderDateAction } from 'src/pages/orders/redux/actions';
import { setFimFilterDates } from 'src/pages/more/redux/actions';
import { addDaysToDate } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';
import {VISIBLE} from 'src/constants/appConstants';
import {  shallowEqual } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ActionsPanel = (props) => {
    const { margin,backgroundColor, buttonMargin, isFim, startLabelMargin, 
        endLabelMargin, dateMargin, setUserSelectedStartDate, setUserSelectedEndDate,
        userSelectedStartDate } = props;
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const listViewStartDate = useSelector(
        (state) => state.filterReducer.listViewStartDate
    );
    const listViewEndDate = useSelector(
        (state) => state.filterReducer.listViewEndDate
    );
    const fimStartDate = useSelector(
        (state) => state.dashboardListReducer.fimStartDate
    );
    const fimEndDate = useSelector(
        (state) => state.dashboardListReducer.fimEndDate
    );

    const {defaultDate} = useSelector(
        (state) => state.dashboardListReducer
    );

    const userFilters = useSelector((state) => state.filterReducer.userFilters);
    const calendarView = useSelector(
        (state) => state.filterReducer.calendarView
    );

    const actionItemsOnly = useSelector(
        (state) => state.filterReducer.actionItemsOnly
    );

    const orderViewData = useSelector(
        (state) => state.ordersReducer.viewData.surgeryDates
    );

    const surgeryStartDate = orderViewData != null ? orderViewData[0] : '';

    const classes = useStyles();

    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const employeeRole = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.employeeRole
    );

    const awaitingPoVisibility = useSelector(
        (state) => state.loginReducer.awaitingPoVisibility
    );

    const minSurgeryImpersonatedDate = useSelector(
        (state) =>
            state.impersonatedUserDataReducer.hybrisUserDetails.minSurgeryDate
    );
    const minSurgeryUserDate = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.minSurgeryDate
    );

    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );

     const appliedFilters = useSelector(
        (state) => state.appliedFiltersReducer,
        shallowEqual
    );
    const selectedViewFilter = useSelector(
        (state) => state.filterReducer.userFilters.filterParam
    );

    const defaultCalendarViewId = useSelector(
        (state) => state.appliedFiltersReducer.defaultCalendarViewId
    );
    const displayFilters = useSelector(
        (state) => state.appliedFiltersReducer.displayFilters,
        shallowEqual
    );

    const minSurgeryDate = isImpersonationActive
        ? minSurgeryImpersonatedDate
        : minSurgeryUserDate;

    // const minSurgeryDate = useSelector((state)=>state.loginReducer.hybrisUserDetails.minSurgeryDate || state.impersonatedUserDataReducer.hybrisUserDetails.minSurgeryDate);

    const [firstListStartDate, setFirstListStartDate] = useState();

    useEffectWithErrorLogging(() => {
        setFirstListStartDate(addDaysToDate(minSurgeryDate, 0));
    }, [minSurgeryDate]);

    useEffectWithErrorLogging(() => {
        props.setOrderListStartDate
            ? props.setOrderListStartDate(firstListStartDate)
            : '';
    }, [firstListStartDate]);

    function handleClearClick() {
        const allView = appliedFilters.basicFilters?.find(
            (filter) => filter.id === 'All'
        );
        const allViewId = allView ? allView.id : '';
        
        dispatch(setSelectedCalendarView(allView || {}));
        dispatch(setOrderCondition(true));
        dispatch(
            setFilters({
                filterParam: allViewId,
                filterByPhysician: [],
                filterByOrderStatus: [],
                orderType: [],
                filterByAccounts: [],
                filterByProcedure: [],
            })
        );
        dispatch(
            putFilterOptions({
                fields: 'DEFAULT',
                calendarSelection: allViewId,
                filteredOrderTypes: '',
                filteredAccounts: '',
                filteredOrderStatuses: '',
                filteredPhysicians: '',
                filteredProcedures: '',
                assignedFlag: true,
            })
        );
    }

    const setStartDateHandler = (startDate) => {
        const normalizedStartDate =
            startDate === null || startDate === undefined || startDate === ''
                ? addDaysToDate(props.minDate?props.minDate:minSurgeryDate, 0)
                : startDate;

            if(!isFim)
            {props.startDate || props.startDate === ''
            ? dispatch(
                  setOrderDateAction({
                      orderListStartDate: convertDateToISOString(
                          normalizedStartDate,
                          'start'
                      ),
                  })
              )
                ? props.setFirstOrderStartDate(normalizedStartDate)
                : ''
            : dispatch(setListViewStartDate(normalizedStartDate));
              setFirstListStartDate(normalizedStartDate);
            }
            else{ 
                setUserSelectedStartDate(normalizedStartDate);
            }
    };

    const setEndDateHandler = (endDate) => {
        const normalizedEndDate =
            endDate === null || endDate === undefined || endDate === ''
                ? new Date()
                : endDate;
        if(!isFim)
        {props.endDate || props.endDate === ''
            ? dispatch(
                  setOrderDateAction({
                      orderListEndDate: convertDateToISOString(
                          normalizedEndDate,
                          'end'
                      ),
                  })
              )
            : dispatch(setListViewEndDate(normalizedEndDate));
        }
        else{
            setUserSelectedEndDate(normalizedEndDate);
        }
    };

    const applyDateSelection = () => {
        dispatch(
            setFilters({
                startDate: firstListStartDate
                    ? convertDateToISOString(
                          new Date(firstListStartDate),
                          'start'
                      )
                    : '',
                endDate: listViewEndDate
                    ? convertDateToISOString(new Date(listViewEndDate), 'end')
                    : '',
            })
        );

        ((props.startDate || props.startDate === '') || (isFim))
            ? props.dateChangeHandler()
            : dispatch(
                  getListData({
                      ...userFilters,
                      startDate: firstListStartDate
                          ? convertDateToISOString(
                                new Date(firstListStartDate),
                                'start'
                            )
                          : '',
                      endDate: listViewEndDate
                          ? convertDateToISOString(
                                new Date(listViewEndDate),
                                'end'
                            )
                          : '',
                  })
              );
    };
    const handleToggleChange = (e) => {
        e.preventDefault();
        if (!actionItemsOnly) {
            dispatch(setActionItemsOnly(true));
        } else {
            dispatch(setActionItemsOnly(false));
        }
    };

    const { appliedCategory, appliedQuickFilter } = useSelector(
        (state) => state.orderFilterReducer
    );

    const AfterToggleChecked = () => {
        props.toggleCheckedHandler(!props.desktopToggleChecked);
    };
    const AfterToggleCheckedDeniedOverride = () => {
        props.deniedOverrideToggleCheck(!props.deniedOverrideToggle);
    };

    const dateFallback = new Date(addDaysToDate(new Date(new Date().setHours(0, 0, 0, 0)), 0));

    return (
        <>
            <ActionsPanelContainer
                calendarView={calendarView}
                padding={props.padding}
                isOrdersListView={props.isOrdersListView}
                backgroundColor={backgroundColor}
                noPadding={props.noPadding}
                filterPanelMargin={props.filterPanelMargin}
            >
                {(calendarView === 'List' ||
                    props.isOrdersListView === true) && (
                    <DesktopFilterActions calendarView={calendarView}>
                        <FormContainer>
                            <FormFieldConatiner>
                                <Label
                                    margin={startLabelMargin ? startLabelMargin : margin ? margin : '0 5px 0 0'}
                                    mbMargin={'0 5px 0 0'}
                                >
                                    {t('calendar.actionPanel.startLabel')}
                                </Label>
                                <FieldContainer className={classes.container}>
                                    <Datepicker
                                     panelWidth={'111px'}
                                        dropdownPanelWidth={'111px'}
                                     id="orders-actionspanel-start-date-datepicker"
                                        smbWidth={'100px'}
                                        smbIconPaddingTop={'0%'}
                                        onChange={setStartDateHandler}
                                        selectedDateFromDatePicker={
                                            !isFim ? (props.startDate ||
                                            props.startDate === ''
                                                ? props.startDate
                                             : firstListStartDate)
                                             : (props.startDate)
                                        }
                                        datePickerCalendarIcon={DatePickerFrom}
                                        datePickerDivWidth="124px"
                                        datePickerDivHeight="30px"
                                        iconHeight={props.iconHeight}
                                        iconPaddingTop={props.iconPaddingTop}
                                        iconRight={props.iconRight}
                                        left={
                                            props.ordersDateIconLeft
                                                ? props.ordersDateIconLeft
                                                : '15px'
                                        }
                                        datePickerBgColor={'#ffffff'}
                                        datePickerDivMbWidth={
                                            props.datePickerDivMbWidth
                                        }
                                        datePickerDivMbHeight={
                                            props.datePickerDivMbHeight
                                        }
                                        datePopOverZIndex={isFim ? "9999997" : "2601"}
                                        maxDate={
                                            !isFim ? 
                                            (props.startDate ||
                                            props.startDate === ''
                                                ? props.endDate
                                                    ? props.endDate
                                                    : new Date(
                                                          addDaysToDate(
                                                              new Date(
                                                                  new Date().setHours(
                                                                      0,
                                                                      0,
                                                                      0,
                                                                      0
                                                                  )
                                                              ),
                                                              0
                                                          )
                                                      )
                                                : new Date(listViewEndDate))
                                            : (!!defaultDate?.surgeryEndDate && new Date(defaultDate.surgeryEndDate)) 
                                                || props.endDate || dateFallback
                                        }
                                        minDate={
                                            !isFim? (props.minDate
                                                ? new Date(
                                                      addDaysToDate(
                                                          new Date(
                                                              props.minDate
                                                          ),
                                                          0
                                                      )
                                                  )
                                                : new Date(
                                                      addDaysToDate(
                                                          new Date(
                                                              minSurgeryDate
                                                          ),
                                                          0
                                                          // new Date(
                                                          //     new Date().setHours(
                                                          //         0,
                                                          //         0,
                                                          //         0,
                                                          //         0
                                                          //     )
                                                          // )
                                                          // 0
                                                      )
                                                  )) :
                                            (!!defaultDate?.surgeryStartDate && new Date(defaultDate.surgeryStartDate)) 
                                                || props.startDate || dateFallback
                                        }/>
                                </FieldContainer>
                            </FormFieldConatiner>
                            <FormFieldConatiner dateMargin={dateMargin}>
                                <Label
                                    margin={endLabelMargin ? endLabelMargin : margin ? margin : '0 5px 0 5px'}
                                    mbMargin={'0px'}
                                >
                                    {t('calendar.actionPanel.endLabel')}
                                </Label>
                                <FieldContainer className={classes.container}>
                                    <Datepicker
                                        panelWidth={'auto'}
                                        dropdownPanelWidth={'auto'}
                                        id="orders-actionspanel-end-date-datepicker"
                                        smbWidth={'100px'}
                                        smbIconPaddingTop={'0%'}
                                        onChange={setEndDateHandler}
                                        selectedDateFromDatePicker={
                                            !isFim? (props.endDate ||
                                            props.endDate === ''
                                                ? props.endDate
                                                 : listViewEndDate )
                                                 : (props.endDate)
                                        }
                                        datePickerCalendarIcon={DatePickerTo}
                                        datePickerDivWidth="124px"
                                        datePickerDivHeight="30px"
                                        iconHeight={props.iconHeight}
                                        iconPaddingTop={props.iconPaddingTop}
                                        iconRight={props.iconRight}
                                        datePickerBgColor={'#ffffff'}
                                        left={
                                            props.ordersDateIconLeft
                                                ? props.ordersDateIconLeft
                                                : '15px'
                                        }
                                        datePickerDivMbWidth={
                                            props.datePickerDivMbWidth
                                        }
                                        datePickerDivMbHeight={
                                            props.datePickerDivMbHeight
                                        }
                                        datePopOverZIndex={isFim ? "9999997" : "2601"}
                                        minDate={
                                            (!isFim)?
                                            (props.endDate ||
                                            props.endDate === ''
                                                ? props.startDate
                                                    ? props.startDate
                                                    : new Date(
                                                          addDaysToDate(
                                                              new Date(
                                                                  new Date().setHours(
                                                                      0,
                                                                      0,
                                                                      0,
                                                                      0
                                                                  )
                                                              )
                                                              //   -365
                                                          )
                                                      )
                                                : new Date(firstListStartDate))
                                            : ( userSelectedStartDate || 
                                                (!!defaultDate?.surgeryStartDate && new Date(defaultDate.surgeryStartDate))) 
                                                || props.startDate || dateFallback
                                        }
                                        maxDate={
                                            !isFim? ((props.endDate ||
                                                props.endDate === '') &&
                                            new Date(
                                                addDaysToDate(
                                                    new Date(
                                                        new Date().setHours(
                                                            0,
                                                            0,
                                                            0,
                                                            0
                                                        )
                                                    ),
                                                    0
                                                )
                                            )):
                                            (!!defaultDate?.surgeryEndDate && new Date(defaultDate.surgeryEndDate)) 
                                                || props.endDate || dateFallback
                                        }
                                        />
                                </FieldContainer>
                            </FormFieldConatiner>
                            <Button
                             id={'orders-actionspanel-apply-date-selection-button'}
                                height={'30px'}
                                width={
                                    isLanguageChanged ? 'max-content' : '78px'
                                }
                                borderRadius={'25px'}
                                margin={buttonMargin ? buttonMargin : '2px 15px 2px auto'}
                                listViewApply
                                show={true}
                                clicked={applyDateSelection}
                                disabled={
                                    props.isOrdersListView ||
                                    props.isCaledarListView
                                        ? props.isApplyEnabled()
                                        : false
                                }
                                fontSize={
                                    props.isOrdersListView ? '14px' : false
                                }
                            >
                                {t('calendar.actionPanel.applyLabel')}
                            </Button>
                        </FormContainer>
                        {props.showToggleButtons  && appliedCategory.categoryName ===
                            t(
                                'orders.orderListFilterDropDown.all.categoryName'
                            ) &&
                            props.isOrdersListView && !props.isOrderHistory && awaitingPoVisibility === VISIBLE && (
                                <POToggleButtonContainer>
                                    <ToggleButton
                                     id="orders-actionspanel-awaiting-po-toggle-button"
                                        label={t(
                                            'calendar.actionPanel.awaitingPO'
                                        )}
                                        checked={props.desktopToggleChecked}
                                        onChange={AfterToggleChecked}
                                    />
                                </POToggleButtonContainer>
                            )}
                        {props.showToggleButtons && displayDeniedOverride(
                            checkImpersonationActive() || checkProxyActive()
                                ? sessionStorage.getItem('ProxyUserRole')
                                : employeeRole,
                            countryISOCode
                        ) &&
                            appliedCategory.categoryName ==
                                t(
                                    'orders.orderQuickFilters.deniedUsageOverrides.label'
                                ) &&
                            appliedQuickFilter.label ==
                                t(
                                    'orders.orderQuickFilters.usageOrders.pendingOverride.statusNotes.pendingOverride'
                                ) && (
                                <POToggleButtonContainer>
                                    <ToggleButton
                                     id="orders-actionspanel-my-denied-overrides-toggle-button"
                                        label={t(
                                            'calendar.actionPanel.myDeniedOverrides'
                                        )}
                                        checked={props.deniedOverrideToggle}
                                        onChange={
                                            AfterToggleCheckedDeniedOverride
                                        }
                                        isMobileView={false}
                                    />
                                </POToggleButtonContainer>
                            )}
                    </DesktopFilterActions>
                )}
                {(() => {
                    if (calendarView !== 'List' && !props.isOrdersListView) {
                        return (
                            <FilterResultsPanel
                                {...props}
                                calendarView={calendarView}
                                orderCondition={props.orderCondition}
                                clearFilterHandler = {handleClearClick}
                                widthStyle = {'80%'}
                                mobileWidthStyle = {'100%'}
                            />

                        );
                    } else {
                        return <></>;
                    }
                })()}
                {calendarView === 'List' && !props.isOrdersListView && (
                    <ToggleButton
                     id="orders-actionspanel-action-items-toggle-button"
                        label={t('calendar.actionPanel.actionItemsLabel')}
                        checked={actionItemsOnly}
                        onChange={(e) => handleToggleChange(e)}
                    />
                )}
            </ActionsPanelContainer>
        </>
    );
};

export default ActionsPanel;

export const DesktopFilterActions = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;

    ${media.mobileDevice`
        display: flex;
        flex-grow:1;
    `}
`;

export const ActionsPanelContainer = styled.div`
    display: flex;
    background-color: ${({ backgroundColor }) => backgroundColor || 'white'};
    align-items: center;
    margin: ${(props) =>
        props.filterPanelMargin? props.filterPanelMargin :
        props.calendarView === 'List' || props.isOrdersListView === true
            ? props.margin
                ? props.margin
                : '10px 0px'
            : '0px'};
    padding: ${(props) =>
        props.noPadding? '0px' :
        props.calendarView === 'List' || props.isOrdersListView === true
            ? props.padding
                ? props.padding
                : '3px 12px 3px 5px'
            : '0px'};
    margin-bottom: 5px;

    border-radius: 5px;
    // box-shadow: 0px 3px 6px 0 #e2e2e2;
    justify-content: space-between;
    min-height: 40px;
    height: auto;

    ${media.mobileDevice`
        height: auto;
        margin: 0;
        background-color: transparent;
        box-shadow: none;
    `}
`;

export const FormContainer = styled.div`
    display: flex;
    align-items: center;

    .p-button-rounded {
        height: 80%;
        background-color: #1021eb;
        border: none;
        color: #ffffff;
    }
    .p-disabled {
        background: #aaaaaa;
        border: none;
        color: #140f4b;
        opacity: 0.4;
    }

    ${media.mobileDevice`
        width: 100%;
        justify-content: space-between;
        align-items: flex-end;
    `}
`;

export const FormFieldConatiner = styled.div`
    display: flex;
    // margin: 0 0px;
    margin: ${({ dateMargin }) => (dateMargin ? dateMargin : '0 5px')};
    align-items: center;
    ${media.mobileDevice`
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const Label = styled.label`
    margin: ${({ margin }) => (margin ? margin : '0 5px')};
    font-family: 'AvenirNextWorld Demi';
    font-size: 11px;
    color: #3c3c3c;
    ${media.mobileDevice`
    margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '0 5px')};
    `}
`;

export const FieldContainer = styled.div``;

export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
    },
    textField: {
        width: 150,
        border: '1px solid #4F4F4F59',
        borderRadius: '4px',
        boxShadow: 'none',
        fontFamily: 'AvenirNextWorld Demi',
        fontSize: '11px',
    },
}));

export const POToggleButtonContainer = styled.div`
    padding: 9px;
    margin-right: 15px;
    ${media.mobileDevice`
        display: none;
    `}
`;
